import React from "react";
import LegalLayout from "../../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      seoPath="/terms-of-service"
      intro="These Terms of Service ('Terms') govern your access to and use of the Jollof Fit Kingdom website, applications and connected services (the 'Services'). By using the Services, you agree to these Terms."
      sections={[
        {
          heading: "Accounts",
          body: ["You must provide accurate information when creating an account and keep it up to date. You are responsible for maintaining the confidentiality of your credentials and for all activity under your account."],
        },
        {
          heading: "User Responsibilities & Account Security",
          body: ["You are responsible for safeguarding your account, using a strong password, and notifying us promptly of any unauthorized access or security breach. You agree not to share your account or use it in any way that could harm the Services or other users."],
        },
        {
          heading: "Acceptable Use",
          body: ["You agree to use the Services lawfully and responsibly."],
          list: [
            "Do not misuse, disrupt or attempt to gain unauthorized access to the Services.",
            "Do not reverse engineer, scrape or exploit the Services except as permitted by law.",
            "Do not upload unlawful, harmful or infringing content.",
          ],
        },
        {
          heading: "Subscriptions & Billing",
          body: ["Certain premium features require a Kingdom membership subscription."],
          list: [
            "Subscriptions are purchased through the applicable app store, such as the Apple App Store or Google Play.",
            "Billing and renewal are handled through the applicable store, and subscriptions renew according to their terms unless cancelled.",
            "You can cancel at any time through your Google Play or Apple subscription settings.",
            "Any free-trial terms, prices and currency are displayed at the point of purchase through the applicable store.",
            "Refunds, where applicable, are governed by the relevant app-store policies.",
          ],
        },
        {
          heading: "Automated Recommendations Disclaimer",
          body: ["The Services use automated technology to generate coaching, insights and scores. These outputs are for informational and motivational purposes only, may not always be accurate, and should not be relied upon as professional advice."],
        },
        {
          heading: "Health Disclaimer",
          body: ["Jollof Fit Kingdom provides fitness and wellness tools, not a substitute for professional guidance. Always listen to your body and consult a qualified professional before starting or changing any exercise or nutrition program."],
        },
        {
          heading: "Medical Disclaimer",
          body: ["The Services do not provide medical advice, diagnosis or treatment. Never disregard professional medical advice or delay seeking it because of something you have read or received through the Services. In an emergency, contact your local emergency services."],
        },
        {
          heading: "Intellectual Property",
          body: [
            "The Services, including all software, design, trademarks and content, are owned by Jollof Fit Kingdom or its licensors and are protected by intellectual property laws. We grant you a limited, non-exclusive, non-transferable license to use the Services for personal, non-commercial purposes.",
            "The following belong exclusively to Jollof Fit Kingdom and may not be copied, reproduced or used without prior written permission:",
          ],
          list: [
            "The JF Logo",
            "The Official Eagle Artwork",
            "Kingdom Score™",
            "Kingdom Insights",
            "The website design",
            "The mobile application",
            "All branding and graphics",
            "All software and source code",
          ],
        },
        {
          heading: "User-Generated Content",
          body: ["You retain ownership of content you submit, including progress photos. By submitting content, you grant us a worldwide, royalty-free license to host, process and display it as necessary to operate the Services. You are responsible for the content you provide."],
        },
        {
          heading: "Termination",
          body: ["We may suspend or terminate your access to the Services if you violate these Terms or where necessary to protect the Services or other users. You may stop using the Services and delete your account at any time."],
        },
        {
          heading: "Warranty Limitations",
          body: ["The Services are provided 'as is' and 'as available' without warranties of any kind, whether express or implied, including fitness for a particular purpose, accuracy and non-infringement, to the maximum extent permitted by law."],
        },
        {
          heading: "Liability Limitations",
          body: ["To the maximum extent permitted by law, Jollof Fit Kingdom shall not be liable for any indirect, incidental, special, consequential or punitive damages, or for any loss of data, profits or goodwill arising from your use of the Services."],
        },
        {
          heading: "Third-Party Integrations",
          body: ["The Services may connect to supported third-party devices, platforms and services (such as smart scales, wearables and health platforms). Your use of those integrations is subject to the third party's own terms and privacy policies. Jollof Fit Kingdom is not responsible for third-party services and cannot guarantee their availability, accuracy or continued compatibility."],
        },
        {
          heading: "Governing Law",
          body: ["These Terms are governed by applicable law without regard to conflict-of-law principles. Any disputes shall be resolved in the courts of competent jurisdiction, unless otherwise required by mandatory local law."],
        },
        {
          heading: "Changes to These Terms",
          body: ["We may update these Terms from time to time. Continued use of the Services after changes take effect constitutes acceptance of the revised Terms."],
        },
      ]}
    />
  );
}
